const globals = {
  logout: {
    en: 'Logout',
    de: 'Ausloggen'
  },
  search: {
    en: 'Search',
    de: 'Suche'
  },
  darkmode: {
    en: 'Dark Mode',
    de: 'Nachtmodus'
  },
  username: {
    en: 'Username',
    de: 'Benutzername'
  },
  name: {
    en: 'Name'
  },
  email: {
    en: 'E-Mail'
  },
  firstname: {
    en: 'Fistname',
    de: 'Vorname'
  },
  lastname: {
    en: 'Lastname',
    de: 'Familienname'
  },
  save_changes: {
    en: 'Save Changes',
    de: 'Änderungen speichern'
  },
  updated: {
    en: 'Updated',
    de: 'Geändert'
  },
  language: {
    en: 'Language',
    de: 'Sprache'
  },
  general: {
    en: 'General',
    de: 'Allgmein'
  },
  notifications: {
    en: 'Notifications',
    de: 'Benachrichtigungen'
  },
  change_password: {
    en: 'Change Password',
    de: 'Passwort ändern'
  },
  history: {
    en: 'History/Logs',
    de: 'Historie/Logs'
  },
  user_settings: {
    en: 'User-Settings',
    de: 'Benutzer-Einstellungen'
  },
  batch_details: {
    en: 'Batch-Details',
    de: 'Batch-Detailansicht'
  },
  banderol_details: {
    en: 'Banderol-Details',
    de: 'Banderolen-Detailansicht'
  },
  product_details: {
    en: 'Product-Details',
    de: 'ProduKt-Detailansicht'
  },

  home: {
    en: 'Home'
  },
  settings: {
    en: 'Settings',
    de: 'Einstellungen'
  },
  settings_user: {
    en: 'User-Management',
    de: 'Benutzer-Verwaltung'
  },
  settings_ou: {
    en: 'OU-Management',
    de: 'OU-Verwaltung'
  },
  settings_rule: {
    en: 'Rule-Management',
    de: 'Regel-Verwaltung'
  },
  settings_page: {
    en: 'Page-Management',
    de: 'Page-Verwaltung'
  },
  settings_vgroups: {
    en: 'Verification groups',
    de: 'Verifikationsgruppen'
  },
  settings_html_header: {
    en: 'HTML-Header'
  },

  products: {
    en: 'Product Settings',
    de: 'Produkt Einstellungen'
  },
  products_product: {
    en: 'Products',
    de: 'Produkte'
  },
  products_banderol: {
    en: 'Labels',
    de: 'Labels'
  },
  products_rpdesigner: {
    en: 'RP Designer',
    de: 'RP Gestalter'
  },
  products_pages: {
    en: 'Pages',
    de: 'Seiten'
  },
  analytics: {
    en: 'Analytics',
    de: 'Analyse'
  },
  analytics_dashboard: {
    en: 'Dashboard',
    de: 'Übersicht'
  },
  analytics_verifications: {
    en: 'Verifications',
    de: 'Verifikationen'
  },
  analytics_greymarket: {
    en: 'Greymarket',
    de: 'Graumarkt'
  },
  analytics_item: {
    en: 'Item'
  },

  codes: {
    en: 'Codes'
  },
  codes_download: {
    en: 'Download',
    de: 'Herunterladen'
  },
  codes_orders: {
    en: 'Orders',
    de: 'Bestellungen'
  },
  codes_batches: {
    en: 'Batches'
  }
}

const products = {
  name: {
    en: 'Name'
  },
  description: {
    en: 'Description',
    de: 'Beschreibung'
  },
  gs1_01: {
    en: 'GTIN'
  },
  count: {
    en: 'Count',
    de: 'Anzahl'
  },
  email: {
    en: 'E-Mail'
  },
  phone: {
    en: 'Phone',
    de: 'Telefon'
  }
}

const notifications = {
  neworder: {
    en: 'Email me when a new order was created',
    de: 'Sende eine E-Mail, wenn eine neue Bestellung angelegt wurde'
  },
  newbatch: {
    en: 'Email me when a new batch was created',
    de: 'Sende eine E-Mail, wenn ein neuer Batch angelegt wurde'
  },
  newproduct: {
    en: 'Email me when a new product was created',
    de: 'Sende eine E-Mail, wenn ein neues Produkt angelegt wurde'
  },
  editorder: {
    en: 'Email me when a order I created was changed',
    de: 'Sende eine E-Mail, wenn eine von mir erstellte Bestellung geändert wurde'
  },
  editbatch: {
    en: 'Email me when a batch I created was changed',
    de: 'Sende eine E-Mail, wenn ein von mir erstellter Batch geändert wurde'
  }
}

const change_password = {
  oldpassword: {
    en: 'Old Password',
    de: 'Altes Passwort'
  },
  newpassword: {
    en: 'New Password',
    de: 'Neues Passwort'
  },
  confirmnewpassword: {
    en: 'Confirm New Password',
    de: 'Neues Passwort bestätigen'
  }
}

function getValueInLanguage(val, language){
  if (!val)
    return 'not found'

  return val[language] || val[Object.keys(val)[0]] || 'not found'
}

export {globals, products, notifications, change_password, getValueInLanguage};
